import React, { useState } from 'react';
import { DiscountType } from 'app/shared/model/DiscountType';
import { Modal, Button, Card, Row, Col, Typography } from 'antd';
import {
  GlobalOutlined,
  TagsOutlined,
  PlusOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

interface DiscountOption {
  type: DiscountType, 
  header: string, 
  description: string, 
  icon: React.ReactNode
}

const discountOptions: DiscountOption[] = [
  {
    type: DiscountType.marketDiscount, 
    header: "Market Discount", 
    description: "Discount prices for all bookings made from a region or country within a set period. Market Discounts are applied to bookings before Special Offers.",   
    icon: <GlobalOutlined />,
  }, 
  {
    type: DiscountType.specialOffer, 
    header: "Special Offer", 
    description: "Discount prices for selected products or agents. Special Offers are applied to bookings in addition to any Market Discount.",  
    icon: <TagsOutlined />,
  }
]; 
  
const AddDiscountModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleCancel = () => setOpen(false);

  return (
    <>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleOpen}
      >
        Add Discount
      </Button>

      <Modal
        title="Select discount type"
        open={open}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        <Row gutter={[16, 16]} justify="center">
          {discountOptions.map((option) => (
            <Col xs={24} sm={12} key={option.type}>
              <Card
                title={
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {option.icon}
                    <Title level={5} style={{ margin: 0 }}>
                      {option.header}
                    </Title>
                  </span>
                }
                actions={[
                  <a key="add" href={`/discount?type=${option.type}`}>
                    Add Discount
                  </a>,
                ]}
              >
                <Paragraph>{option.description}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal>
    </>
  );
};

export default AddDiscountModal;
  
  